import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { ComplexMapFieldValue, DialogConfig, DialogRef } from '@stylehaven/components';
import {
    SelectionDialogOutput,
    SelectionDialogOutputCancel,
    SelectionDialogOutputSuccess
} from '../../../dialog/dialog.module';
import { WebserviceConfig } from '../../entities/webservice-config.entity';

@Component({
    standalone: false,
    selector: 'med-webservice-search-dialog',
    templateUrl: './webservice-search-dialog.component.html',
    styleUrls: ['./webservice-search-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebserviceSearchDialogComponent {
    public webserviceConfig: WebserviceConfig;
    public multiple: boolean;

    public selection$: BehaviorSubject<ComplexMapFieldValue[]> = new BehaviorSubject<ComplexMapFieldValue[]>([]);

    constructor(
        public dialogConfig: DialogConfig,
        public dialog: DialogRef<SelectionDialogOutput>
    ) {
        if (dialogConfig.data) {
            this.webserviceConfig = dialogConfig.data.webserviceConfig;
            this.multiple = dialogConfig.data.multiple;
        }
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: { target: HTMLInputElement }) {
        // Prevent submitting when form is invalid
        if (!this.selection$.value) {
            return;
        }
        this.submit();
    }

    public onSelection(selection: ComplexMapFieldValue[]): void {
        this.selection$.next(selection);
    }

    submit(): void {
        const selection: ComplexMapFieldValue[] = this.selection$.value;
        const output: SelectionDialogOutputSuccess = { type: 'success', selection };

        this.dialog.close(output);
    }

    cancel(): void {
        const cancel: SelectionDialogOutputCancel = { type: 'cancel' };
        this.dialog.close(cancel);
    }
}
